import React from 'react';

// Styles & Assets
import styles from './SettingsAdministrationPage.module.css';
import doctorSVG from '../../assets/icons/doctor.svg';
import deviceSVG from '../../assets/icons/mobile-device.svg';
import mapSVG from '../../assets/icons/map.svg';
import chartsSVG from '../../assets/icons/charts.svg';
import customizeSVG from '../../assets/icons/customize.svg';
import settingsSVG from '../../assets/icons/settings.svg';

// Compoments
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import AdministrationOption from './AdministrationOption';

// Interface
import { AdministrationButton, AdministrationSectionID } from '../../interfaces/Administration';

// Language
import { useTranslation } from 'react-i18next';

// SettingsAdministrationPage: renders the administration page to select between all the
// administration pages.
const SettingsAdministrationPage: React.FC = () => {
    const { t } = useTranslation();

    const hiddenAdministrationButtons: AdministrationSectionID[] = window.config.HIDE_ADMINISTRATION_BUTTONS ?? [];
    const disabledAdministrationButtons: AdministrationSectionID[] = window.config.DISABLED_ADMINISTRATION_BUTTONS ?? [];

    const ADMINISTRATION_OPTIONS: AdministrationButton[] = [
        { id: 'user_management', label: t('users_administration'), logo: doctorSVG, link: 'user_management' },
        { id: 'devices_management', label: t('devices_administration'), logo: deviceSVG, link: 'devices_management' },
        { id: 'zones_bed_management', label: t('zones_administration'), logo: mapSVG, link: 'zones_bed_management' },
        { id: 'statistics', label: t('statistics'), logo: chartsSVG, disabled: window.config.POWER_BI_URL === null, target: true, link: window.config.POWER_BI_URL ?? '' },
        { id: 'scores_management', label: t('scores'), logo: customizeSVG, link: 'scores_management' },
        { id: 'preconfiguration', label: t('preconfigurations'), logo: settingsSVG, link: 'preconfiguration' },
    ];

    return (
        <div className='pageContainer'>
            <Toolbar />
            <div className={styles.administrationContainer}>
                {ADMINISTRATION_OPTIONS.map(option => !hiddenAdministrationButtons.includes(option.id) &&
                    <AdministrationOption
                        key={option.id}
                        option={{
                            ...option,
                            disabled: option.disabled || disabledAdministrationButtons.includes(option.id)
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default SettingsAdministrationPage;